import { render, staticRenderFns } from "./HomeworkAdd.vue?vue&type=template&id=6d66378d&lang=pug&"
import script from "./HomeworkAdd.vue?vue&type=script&lang=js&"
export * from "./HomeworkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports